import './LeftTop.css';

export const LeftTop = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="left-top">
      {children}
    </div>
  )
}
